export const categories = [
  {
    slug: 'platform-recommend',
    name: '平台推荐',
    description: '精选合规成人短视频平台，涵盖国内外主流选择，提供详细评测与对比。',
    icon: 'ri-smartphone-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20platform%20interface%20display%20with%20warm%20ambient%20lighting%2C%20clean%20flat%20design%20aesthetic%2C%20soft%20neutral%20background%20with%20subtle%20gradients%2C%20professional%20editorial%20photography%20style%2C%20no%20text%2C%20abstract%20digital%20concept&width=800&height=500&seq=cat-platform-01&orientation=landscape',
    articleCount: 24,
  },
  {
    slug: 'content-classification',
    name: '内容分类',
    description: '深入了解成人短视频内容类型划分，帮助您精准定位兴趣方向。',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20content%20organization%20concept%20with%20soft%20warm%20tones%2C%20abstract%20grid%20layout%20with%20categorized%20visual%20elements%2C%20clean%20modern%20aesthetic%2C%20neutral%20beige%20background%2C%20professional%20editorial%20style%2C%20soft%20ambient%20lighting&width=800&height=500&seq=cat-content-02&orientation=landscape',
    articleCount: 18,
  },
  {
    slug: 'safety-guide',
    name: '安全指南',
    description: '保护个人隐私与设备安全，学习安全浏览技巧与风险防范措施。',
    icon: 'ri-shield-check-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20security%20and%20protection%20concept%20with%20warm%20neutral%20tones%2C%20shield%20metaphor%20in%20soft%20geometric%20shapes%2C%20clean%20modern%20aesthetic%2C%20soft%20beige%20background%2C%20professional%20editorial%20photography%20style%2C%20subtle%20gradients&width=800&height=500&seq=cat-safety-03&orientation=landscape',
    articleCount: 15,
  },
  {
    slug: 'privacy-protection',
    name: '隐私保护',
    description: '全方位的隐私保护策略，涵盖浏览记录管理、账户安全与匿名访问技巧。',
    icon: 'ri-lock-line',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20privacy%20and%20data%20protection%20concept%20with%20warm%20ambient%20tones%2C%20abstract%20lock%20and%20key%20geometric%20shapes%2C%20clean%20modern%20aesthetic%2C%20soft%20beige%20background%2C%20professional%20editorial%20style%2C%20subtle%20lighting&width=800&height=500&seq=cat-privacy-04&orientation=landscape',
    articleCount: 12,
  },
  {
    slug: 'legal-compliance',
    name: '合规法规',
    description: '了解国内外成人内容相关法律法规，确保您的观看行为合法合规。',
    icon: 'ri-scales-line',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20legal%20and%20compliance%20concept%20minimalist%20style%2C%20warm%20neutral%20tones%2C%20clean%20geometric%20balance%20scales%20metaphor%2C%20soft%20beige%20background%2C%20professional%20editorial%20photography%2C%20modern%20aesthetic&width=800&height=500&seq=cat-legal-05&orientation=landscape',
    articleCount: 10,
  },
  {
    slug: 'tech-tools',
    name: '技术工具',
    description: '推荐实用的观看工具、播放器、下载管理器及相关技术解决方案。',
    icon: 'ri-tools-line',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20technology%20tools%20concept%20with%20warm%20ambient%20lighting%2C%20abstract%20digital%20tool%20icons%20in%20geometric%20shapes%2C%20clean%20flat%20design%20aesthetic%2C%20soft%20neutral%20background%2C%20professional%20editorial%20style&width=800&height=500&seq=cat-tech-06&orientation=landscape',
    articleCount: 8,
  },
];

export const platforms = [
  {
    id: 'p1',
    name: 'PrimeVision',
    rating: 4.8,
    description: '国际领先的成人短视频平台，拥有海量高清内容和严格的年龄验证机制，支持多语言界面。',
    features: ['4K超高清画质', 'AI智能推荐', '严格年龄验证', '端到端加密'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20entertainment%20platform%20brand%20visualization%2C%20warm%20dark%20red%20and%20gold%20accents%2C%20clean%20professional%20aesthetic%2C%20soft%20neutral%20background%2C%20premium%20editorial%20style%2C%20abstract%20geometric%20brand%20identity&width=600&height=400&seq=platform-01&orientation=landscape',
    categorySlug: 'platform-recommend',
  },
  {
    id: 'p2',
    name: 'SensualStream',
    rating: 4.6,
    description: '专注于高质量短视频内容，提供个性化推荐算法，支持创作者与用户直接互动。',
    features: ['个性化推荐', '创作者互动', '多设备同步', '隐私模式'],
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20streaming%20platform%20brand%20visualization%2C%20warm%20copper%20and%20cream%20tones%2C%20clean%20modern%20aesthetic%2C%20soft%20neutral%20background%2C%20premium%20editorial%20photography%20style%2C%20abstract%20flowing%20shapes&width=600&height=400&seq=platform-02&orientation=landscape',
    categorySlug: 'platform-recommend',
  },
  {
    id: 'p3',
    name: 'VelvetHub',
    rating: 4.5,
    description: '注重用户隐私保护的成人内容平台，采用区块链技术保障数据安全与匿名访问。',
    features: ['区块链加密', '匿名访问', '社区互动', '定期安全审计'],
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20minimalist%20privacy%20focused%20platform%20brand%20visualization%2C%20deep%20burgundy%20and%20soft%20gold%20accents%2C%20clean%20modern%20aesthetic%2C%20neutral%20warm%20background%2C%20premium%20editorial%20style%2C%20abstract%20geometric%20patterns&width=600&height=400&seq=platform-03&orientation=landscape',
    categorySlug: 'platform-recommend',
  },
];

export const articles = [
  {
    slug: '2024-adult-short-video-platform-ranking',
    title: '2024年成人短视频平台综合排名与深度评测',
    excerpt: '基于内容质量、隐私安全、用户体验等多维度，对主流成人短视频平台进行全面评测与排名分析。',
    content: `<p>随着短视频行业的蓬勃发展，成人短视频平台也迎来了快速增长期。本文将从多个维度对当前主流的成人短视频平台进行全面评测，帮助您在众多选择中找到最适合自己的平台。</p>
<h2>评测标准</h2>
<p>我们采用以下核心指标进行评测：内容质量与多样性（30%）、隐私保护措施（25%）、用户界面体验（20%）、社区互动功能（15%）、合规性与安全性（10%）。</p>
<h2>Top 1: PrimeVision</h2>
<p>作为行业领先者，PrimeVision 在内容质量和隐私保护方面表现卓越。该平台采用先进的 AI 内容审核系统，确保所有内容符合法律法规要求。其端到端加密技术为用户提供了最高级别的隐私保护。</p>
<h2>Top 2: SensualStream</h2>
<p>SensualStream 以其出色的个性化推荐算法脱颖而出。平台利用深度学习技术分析用户偏好，提供精准的内容推荐。同时，其多设备无缝同步功能大大提升了用户体验。</p>
<h2>Top 3: VelvetHub</h2>
<p>VelvetHub 是隐私保护领域的标杆，率先采用区块链技术保障用户数据安全。其匿名访问模式让用户可以完全放心地浏览内容。</p>
<h2>选择建议</h2>
<p>选择平台时，建议优先考虑隐私保护措施完善、内容审核严格、有明确年龄验证机制的平台。同时，注意查看平台的用户协议和隐私政策，了解您的数据如何被收集和使用。</p>`,
    categorySlug: 'platform-recommend',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20minimalist%20platform%20ranking%20concept%20with%20warm%20burgundy%20and%20gold%20accents%2C%20clean%20modern%20aesthetic%2C%20abstract%20trophy%20and%20ranking%20geometric%20shapes%2C%20soft%20neutral%20background%2C%20editorial%20photography%20style&width=1200&height=630&seq=article-01&orientation=landscape',
    author: '内容编辑团队',
    date: '2024-11-15',
    readTime: '12分钟',
    tags: ['平台评测', '排名', 'PrimeVision', 'SensualStream'],
  },
  {
    slug: 'adult-content-category-comprehensive-guide',
    title: '成人短视频内容分类完全指南：找到适合你的类型',
    excerpt: '全面解析成人短视频的各类内容类型，帮助您了解不同分类的特点与适合人群。',
    content: `<p>成人短视频内容丰富多样，了解不同分类有助于您更精准地找到感兴趣的内容。本文将从多个角度对成人短视频内容进行系统分类与解析。</p>
<h2>按内容形式分类</h2>
<p>短视频（1分钟以内）：适合快速浏览，内容精炼直接。中视频（1-5分钟）：内容更加丰富，讲述更完整。长视频（5分钟以上）：深度内容，适合沉浸式观看体验。</p>
<h2>按制作类型分类</h2>
<p>专业制作内容：由专业团队拍摄制作，画面质量高，内容规范。UGC内容：用户自主创作上传，更加多元化和个性化。直播互动内容：实时互动，增加参与感和即时性。</p>
<h2>按主题风格分类</h2>
<p>艺术风格：注重美学表达和视觉艺术感。纪实风格：真实自然，贴近生活。剧情风格：有完整故事情节和角色设定。</p>
<h2>选择建议</h2>
<p>建议初学者从短视频内容开始，逐步了解不同分类的特点。同时，注意合理安排观看时间，保持健康的内容消费习惯。选择合规平台上的正规内容，避免访问来源不明的资源。</p>`,
    categorySlug: 'content-classification',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20content%20categories%20visualization%20with%20warm%20amber%20and%20cream%20tones%2C%20abstract%20grid%20of%20organized%20visual%20elements%2C%20clean%20modern%20aesthetic%2C%20soft%20neutral%20background%2C%20editorial%20style&width=1200&height=630&seq=article-02&orientation=landscape',
    author: '内容编辑团队',
    date: '2024-10-28',
    readTime: '10分钟',
    tags: ['内容分类', '指南', '短视频类型'],
  },
  {
    slug: 'safe-browsing-adult-platform-tips',
    title: '成人短视频平台安全浏览十大必备技巧',
    excerpt: '从设备安全到网络防护，全方位为您解析安全浏览成人短视频平台的核心技巧。',
    content: `<p>在享受成人短视频内容的同时，确保浏览安全至关重要。以下十大技巧将帮助您在数字世界中保护自己。</p>
<h2>1. 使用专用浏览器</h2>
<p>建议为成人内容浏览设置专用浏览器或使用隐私模式，避免浏览记录与日常使用混淆。推荐使用具有增强隐私保护功能的浏览器。</p>
<h2>2. 启用VPN服务</h2>
<p>VPN可以有效隐藏您的真实IP地址，保护您的网络身份。选择无日志政策的可靠VPN服务商。</p>
<h2>3. 定期清理浏览数据</h2>
<p>养成定期清理浏览器缓存、Cookie和浏览历史的习惯，减少个人信息泄露风险。</p>
<h2>4. 使用强密码和双因素认证</h2>
<p>为平台账户设置复杂且独特的密码，并开启双因素认证增加安全层级。</p>
<h2>5. 警惕钓鱼攻击</h2>
<p>不要点击来源不明的链接，仔细验证平台网址的真实性，避免落入钓鱼陷阱。</p>
<h2>6. 安装可靠的安全软件</h2>
<p>保持防病毒软件和防火墙的更新，及时修补系统漏洞。</p>
<h2>7. 谨慎对待下载内容</h2>
<p>避免从不明来源下载文件，防止恶意软件感染。</p>
<h2>8. 管理社交媒体关联</h2>
<p>不要将成人平台账户与个人社交媒体账户关联，保持身份隔离。</p>
<h2>9. 关注平台安全公告</h2>
<p>定期查看所用平台的安全更新和公告，及时了解潜在风险。</p>
<h2>10. 培养安全意识</h2>
<p>持续学习网络安全知识，提高对新型威胁的识别和防范能力。</p>`,
    categorySlug: 'safety-guide',
    coverImage: 'https://readdy.ai/api/search-image?query=Minimalist%20cybersecurity%20and%20safe%20browsing%20concept%20with%20warm%20terracotta%20tones%2C%20abstract%20shield%20and%20lock%20geometric%20shapes%2C%20clean%20modern%20aesthetic%2C%20soft%20neutral%20background%2C%20professional%20editorial%20style&width=1200&height=630&seq=article-03&orientation=landscape',
    author: '安全专家团队',
    date: '2024-10-15',
    readTime: '8分钟',
    tags: ['安全浏览', '隐私保护', '防范技巧'],
  },
  {
    slug: 'privacy-protection-adult-platform-complete',
    title: '成人短视频平台隐私保护全攻略：从入门到精通',
    excerpt: '深度剖析隐私保护策略，从账户设置到网络环境，打造全方位的隐私防护体系。',
    content: `<p>在数字化时代，隐私保护已成为使用成人短视频平台时最受关注的问题之一。本攻略将为您提供从基础到高级的隐私保护方案。</p>
<h2>账户层面保护</h2>
<p>首先，注册时使用独立的邮箱地址，避免与工作或个人邮箱关联。设置高强度密码，并启用生物识别或双因素认证。定期检查账户活动记录，发现异常及时处理。</p>
<h2>支付隐私保护</h2>
<p>使用虚拟信用卡或预付卡进行支付，避免直接使用个人银行卡。部分平台支持加密货币支付，可进一步保护财务隐私。</p>
<h2>浏览隐私保护</h2>
<p>始终使用隐私浏览模式，结合VPN隐藏网络活动。考虑使用Tor网络获得更高级别的匿名保护。定期清除DNS缓存，防止信息残留。</p>
<h2>数据管理策略</h2>
<p>仔细阅读平台的隐私政策，了解数据收集范围和使用方式。定期请求平台删除不必要的数据。使用数据加密工具保护本地存储内容。</p>
<h2>社交媒体隔离</h2>
<p>严格分离成人内容消费和个人社交生活，使用不同设备或用户账户。关闭应用程序的社交分享功能和通讯录访问权限。</p>`,
    categorySlug: 'privacy-protection',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20minimalist%20privacy%20protection%20concept%20with%20warm%20coral%20and%20cream%20tones%2C%20geometric%20lock%20and%20shield%20shapes%20in%20layered%20composition%2C%20clean%20modern%20aesthetic%2C%20soft%20neutral%20background%2C%20editorial%20style&width=1200&height=630&seq=article-04&orientation=landscape',
    author: '隐私保护专家',
    date: '2024-09-20',
    readTime: '15分钟',
    tags: ['隐私保护', '数据安全', '匿名浏览'],
  },
  {
    slug: 'adult-platform-legal-compliance-2024',
    title: '2024年成人短视频平台法律法规合规解读',
    excerpt: '全面梳理国内外成人内容相关法律法规，助您了解合规观看的法律边界与权益保障。',
    content: `<p>了解相关法律法规是理性使用成人短视频平台的基础。本文将对当前适用的法律框架进行全面解读。</p>
<h2>国内法律框架</h2>
<p>根据《中华人民共和国网络安全法》和相关法规，所有互联网内容平台必须建立严格的内容审核机制和年龄验证系统。传播违法违规内容将承担法律责任。</p>
<h2>年龄限制规定</h2>
<p>法律规定，成人内容平台必须确保用户年满18周岁。平台应采用有效的年龄验证机制，包括但不限于身份证验证、人脸识别等技术手段。</p>
<h2>内容合规要求</h2>
<p>平台内容必须符合国家相关规定，不得包含违法信息。平台需建立7×24小时内容审核机制，及时处理违规内容。</p>
<h2>用户权益保护</h2>
<p>用户享有知情权、选择权和隐私权。平台必须明确告知数据收集和使用方式，不得强制收集非必要信息。</p>
<h2>国际法律比较</h2>
<p>不同国家和地区对成人内容的法律规定存在差异。在跨境访问时，需同时遵守来源地和目的地法律。GDPR（欧盟通用数据保护条例）对用户数据保护提出了更高要求。</p>
<h2>合规使用建议</h2>
<p>始终选择已获相关资质的正规平台，仔细阅读用户协议，了解自身权利义务。如遇侵权或违规内容，及时向平台或监管部门举报。</p>`,
    categorySlug: 'legal-compliance',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20minimalist%20legal%20and%20compliance%20concept%20with%20warm%20sienna%20and%20cream%20tones%2C%20abstract%20balance%20scales%20and%20document%20geometric%20shapes%2C%20clean%20modern%20aesthetic%2C%20soft%20neutral%20background%2C%20editorial%20style&width=1200&height=630&seq=article-05&orientation=landscape',
    author: '法律顾问团队',
    date: '2024-09-05',
    readTime: '14分钟',
    tags: ['法律法规', '合规', '用户权益'],
  },
  {
    slug: 'adult-video-tools-recommend-2024',
    title: '2024年成人短视频观看工具与播放器精选推荐',
    excerpt: '精选多款性能优异、安全可靠的播放器与下载管理工具，提升您的观看体验。',
    content: `<p>选择合适的观看工具可以显著提升成人短视频的观看体验。本文推荐一系列经过安全验证的优质工具。</p>
<h2>播放器推荐</h2>
<p>VLC Media Player：开源免费，支持几乎所有视频格式，内置隐私保护功能。PotPlayer：轻量级高性能播放器，支持硬件加速和丰富的自定义选项。</p>
<h2>下载管理工具</h2>
<p>Internet Download Manager：高效的下载管理工具，支持多线程下载和断点续传。使用下载工具时请遵守平台的服务条款和相关法律法规。</p>
<h2>VPN服务推荐</h2>
<p>选择无日志政策、加密强度高的VPN服务。关注服务器覆盖范围、连接速度和隐私保护政策。</p>
<h2>隐私工具套件</h2>
<p>CCleaner：定期清理浏览痕迹和临时文件。BitLocker/VeraCrypt：对敏感文件进行加密存储。Password Manager：管理多平台复杂密码。</p>
<h2>使用注意事项</h2>
<p>从官方渠道下载工具软件，避免使用破解版或来源不明的版本。定期更新软件到最新版本，修补安全漏洞。</p>`,
    categorySlug: 'tech-tools',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20digital%20tools%20and%20software%20concept%20with%20warm%20russet%20and%20cream%20tones%2C%20abstract%20tool%20icons%20in%20geometric%20composition%2C%20clean%20modern%20aesthetic%2C%20soft%20neutral%20background%2C%20editorial%20style&width=1200&height=630&seq=article-06&orientation=landscape',
    author: '技术评测团队',
    date: '2024-08-18',
    readTime: '9分钟',
    tags: ['工具推荐', '播放器', 'VPN'],
  },
  {
    slug: 'newcomer-adult-platform-quick-start',
    title: '成人短视频平台新手快速入门：从注册到安全观看',
    excerpt: '专为初次接触成人短视频平台的用户设计，涵盖注册流程、界面导航与基础安全设置。',
    content: `<p>欢迎来到成人短视频的世界。本指南将帮助您快速熟悉平台操作，同时建立良好的安全习惯。</p>
<h2>第一步：选择合适平台</h2>
<p>参考我们的平台推荐和评测，选择信誉良好、安全性高的合规平台。注意查看平台的年龄验证机制和隐私政策。</p>
<h2>第二步：安全注册账户</h2>
<p>使用独立的邮箱注册，设置高强度密码。完成必要的年龄验证流程。仔细阅读用户协议，了解平台规则。</p>
<h2>第三步：基础隐私设置</h2>
<p>进入账户设置，配置隐私选项：关闭公开个人资料、限制数据收集范围、设置内容偏好。启用双因素认证。</p>
<h2>第四步：熟悉界面导航</h2>
<p>了解平台的主要功能区域：首页推荐、分类浏览、搜索功能、收藏列表和个人中心。善用筛选和排序功能找到感兴趣的内容。</p>
<h2>第五步：建立安全习惯</h2>
<p>使用VPN保护网络隐私，定期清理浏览记录，不在公共网络环境下访问，谨慎对待平台外的链接和广告。</p>
<h2>第六步：合理管理时间</h2>
<p>设定合理的观看时间限制，保持内容消费与日常生活的平衡。培养多元化的兴趣爱好。</p>`,
    categorySlug: 'platform-recommend',
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20getting%20started%20guide%20concept%20with%20soft%20terracotta%20and%20cream%20tones%2C%20abstract%20step%20by%20step%20geometric%20visualization%2C%20clean%20modern%20aesthetic%2C%20neutral%20background%2C%20editorial%20style&width=1200&height=630&seq=article-07&orientation=landscape',
    author: '新手引导团队',
    date: '2024-07-30',
    readTime: '7分钟',
    tags: ['新手入门', '注册指南', '平台导航'],
  },
  {
    slug: 'adult-platform-subscription-payment-guide',
    title: '成人短视频平台订阅与支付方式完全指南',
    excerpt: '详细对比各平台订阅方案，解析安全支付方式，帮助您做出最优选择。',
    content: `<p>选择合适的订阅方案和支付方式是使用成人短视频平台的重要环节。本文为您详细解析各平台的付费选项。</p>
<h2>订阅方案对比</h2>
<p>月付方案：灵活度高，适合短期使用。年付方案：通常享有较大折扣，长期使用更经济。终身会员：一次性付费，适合高频用户。</p>
<h2>安全支付方式</h2>
<p>虚拟信用卡：推荐使用一次性虚拟信用卡，避免泄露真实卡号。加密货币：部分平台支持比特币等加密货币支付，提供更高隐私保护。礼品卡：通过购买平台礼品卡充值，无需关联银行信息。</p>
<h2>支付安全建议</h2>
<p>避免使用个人主要银行卡直接支付。定期检查账单，关注异常扣款。保留支付凭证，以便发生争议时维权。</p>
<h2>免费与付费对比</h2>
<p>免费账户通常有内容限制和广告。付费账户享受高清画质、无广告、独家内容等特权。建议先试用免费版，再决定是否升级。</p>`,
    categorySlug: 'platform-recommend',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20payment%20and%20subscription%20concept%20with%20warm%20amber%20and%20cream%20tones%2C%20abstract%20credit%20card%20and%20coin%20geometric%20shapes%2C%20clean%20modern%20aesthetic%2C%20soft%20neutral%20background%2C%20editorial%20style&width=1200&height=630&seq=article-08&orientation=landscape',
    author: '消费指南团队',
    date: '2024-07-12',
    readTime: '8分钟',
    tags: ['订阅指南', '支付安全', '方案对比'],
  },
];

export const faqs = [
  {
    question: '如何确保在成人短视频平台上的浏览安全？',
    answer: '确保浏览安全的关键措施包括：使用VPN隐藏真实IP地址、启用浏览器的隐私模式、定期清理浏览记录和Cookie、使用独立的专用浏览器、安装并更新防病毒软件、避免在公共WiFi环境下访问。此外，选择有良好声誉和严格安全措施的正规平台也同样重要。',
  },
  {
    question: '成人短视频平台的年龄验证机制是否可靠？',
    answer: '主流合规平台通常采用多重年龄验证机制，包括身份证件上传、人脸识别比对、第三方年龄验证服务等。虽然没有任何系统是100%完美的，但选择具有严格验证流程的平台可以大幅降低未成年人接触不当内容的风险。作为成年用户，您应积极配合平台的验证流程。',
  },
  {
    question: '如何保护个人隐私不被泄露？',
    answer: '保护个人隐私需要多层面的防护：账户层面使用独立邮箱和强密码；网络层面使用VPN和隐私浏览模式；支付层面使用虚拟信用卡或加密货币；数据层面定期清理浏览痕迹和请求平台删除不必要的数据。最重要的是，仔细阅读平台的隐私政策，了解数据使用方式。',
  },
  {
    question: '免费成人短视频平台是否安全？',
    answer: '免费平台的风险通常高于付费平台。免费平台可能通过收集和出售用户数据获利，内容审核可能不够严格，广告和弹窗中可能包含恶意软件。如果使用免费平台，务必加强安全防护措施，谨慎点击任何广告和外部链接，并优先考虑采用"免费增值"模式的平台。',
  },
  {
    question: '使用成人短视频平台是否合法？',
    answer: '合法性取决于多个因素：您所在的地区法律、平台的合规资质、内容的性质等。在大多数国家和地区，成年人访问合法合规的成人内容平台是被允许的。但需注意：必须年满18周岁、内容不得涉及违法元素、不得传播或分享给未成年人。建议了解当地法律法规。',
  },
  {
    question: '如何识别和避免诈骗成人短视频平台？',
    answer: '识别诈骗平台的要点包括：检查网址是否使用HTTPS加密、查看平台是否有明确的运营主体和联系方式、搜索平台的用户评价和媒体报道、警惕收费异常低廉或承诺不切实际的内容、注意平台是否设有合理的退款和投诉机制。如有疑虑，建议先通过第三方评测网站验证平台真实性。',
  },
  {
    question: '成人短视频平台的内容是否经过审核？',
    answer: '合规平台通常设有严格的内容审核机制，包括AI自动审核和人工审核相结合的方式。审核内容涵盖版权合规性、内容适当性和法律合规性。然而，审核标准因平台和地区而异。建议选择透明度高、审核标准明确的平台，并在发现违规内容时及时举报。',
  },
];

export const siteInfo = {
  name: '成人短视频指南',
  tagline: '理性探索，安全观看',
  description: '为18岁以上成年用户提供合规成人短视频平台推荐、内容分类解析、安全观看技巧及隐私保护建议的综合性指南网站。',
  founded: '2024年',
  email: 'contact@adultvideoguide.cn',
};